<template>
  <svg
    id="svg2"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    height="400"
    width="400"
    xml:space="preserve"
    version="1.1">
    <metadata id="metadata8">
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs6">
      <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
        <path
          id="path16"
          d="M 150,300 C 67.157,300 0,232.843 0,150 v 0 C 0,67.157 67.157,0 150,0 v 0 c 82.843,0 150,67.157 150,150 v 0 c 0,82.843 -67.157,150 -150,150 z" />
      </clipPath>
    </defs>
    <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,400)">
      <g id="g12">
        <g id="g14" clip-path="url(#clipPath18)">
          <path
            id="path20"
            style="fill:#0098c3;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -150,300 H 450 V 0 h -600 z" />
          <path
            id="path22"
            style="fill:#e00034;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -150,200 H 450 V 100 h -600 z" />
          <path
            id="path24"
            style="fill:#00ae65;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -150,100 H 450 V 0 h -600 z" />
          <g id="g26" transform="translate(140.5,195)">
            <path
              id="path28"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
              d="m 0,0 c 24.853,0 45,-20.147 45,-45 0,-24.853 -20.147,-45 -45,-45 -24.853,0 -45,20.147 -45,45 0,24.853 20.147,45 45,45" />
          </g>
          <g id="g30" transform="translate(150,187.5)">
            <path
              id="path32"
              style="fill:#e00034;fill-opacity:1;fill-rule:nonzero;stroke:none"
              d="M 0,0 C 20.71,0 37.5,-16.79 37.5,-37.5 37.5,-58.211 20.71,-75 0,-75 -20.711,-75 -37.5,-58.211 -37.5,-37.5 -37.5,-16.79 -20.711,0 0,0" />
          </g>
          <g id="g34" transform="translate(208.1899,132.3344)">
            <path
              id="path36"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
              d="m 0,0 -12.898,6.12 -4.775,-13.454 -4.793,13.448 -12.889,-6.139 6.12,12.899 -13.455,4.774 13.448,4.793 -6.138,12.89 12.898,-6.121 4.774,13.456 4.793,-13.449 12.89,6.138 L -6.145,22.457 7.31,17.683 -6.138,12.89 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Az',
};
</script>
